import { StepperProvider } from "./StepperProvider";

export const StepperWrapper = ({ formStepper, children }) =>
	<StepperProvider formStepper={formStepper}>
		{children}
	</StepperProvider>
